(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/analytics/assets/javascripts/trackanalytics.js') >= 0) return;  svs.modules.push('/components/core/analytics/assets/javascripts/trackanalytics.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.core = svs.core || {};
  svs.core.analytics = svs.core.analytics || {};
  var metric = new svs.core.log.Message(svs.core.log.MessageType.pageview);

  svs.core.log.track('svs.core.analytics', metric);

  svs.core.analytics.timingTest = pageTimingsTest;

  $(document).ready(function() {
    pageTimingsTest();
  });

  function testPerformance(measurements) {
    var perf = window.performance || window.webkitPerformance;
    perf = perf && perf.timing;
    if (perf && perf.navigationStart !== 0) {
      var navstart = perf.navigationStart;
      measurements.totalPageLoadTime = perf.loadEventStart - navstart;
      measurements.serverResponseTime = perf.responseStart - perf.requestStart;
      measurements.pageDownloadTime = perf.responseEnd - perf.responseStart;
      measurements.pageInteractive = perf.domInteractive - navstart;
    }
  }
  function pageTimingsTest() {
    var sendLog = true;
    var perf = window.performance || window.webkitPerformance;
    perf = perf && perf.timing;
    if (perf) {
      if (perf.loadEventEnd < 1) {
        setTimeout(function() {
          pageTimingsTest();
        }, 200);
      } else {
        var sampleRate = parseInt(
          svs.core.analytics.data.svsanalytics.config.siteSpeedSampleRate,
          10
        );
        var sampleNumber = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
        if (sampleNumber <= sampleRate) {
          var logdata = {};
          testPerformance(logdata);
          if (!$.isEmptyObject(logdata)) {
            $.each(logdata, function(key, value) {
              if (!parseInt(value, 10)) {
                sendLog = false;
              }
            });
            if (sendLog) {
              var timings = new svs.core.log.Message(
                svs.core.log.MessageType.timing
              );
              timings.totalPageLoadTime = logdata.totalPageLoadTime;
              timings.serverResponseTime = logdata.serverResponseTime;
              timings.pageDownloadTime = logdata.pageDownloadTime;
              timings.interactivePage = logdata.pageInteractive;
              svs.core.log.track('svs.core.analytics', timings);
            }
          }
        }
      }
    }
  }
})(svs);

 })(window);